import React from 'react';
import { connect } from 'react-redux';
import { Grid, Box, Typography, Chip } from '@mui/material';
import ButtonInc from '../../../shared-ui/ButtonInc';
import ModalInc from '../../../shared-ui/ModalInc';
import AlertDialog from '../../../components/AlertDialog/index.es6';
import SkeletonWrapper from '../../NewProductList/components/SkeletonWrapper/SkeletonWrapper';
import {
  getOrgIppConfigsRequest,
  createOrgIppConfigRequest,
  updateOrgIppConfigRequest,
  deleteOrgIppConfigRequest,
  resetCreateOrgIppConfigError,
  resetUpdateOrgIppConfigError,
  resetDeleteOrgIppConfigError,
} from '../../OrganizationIppConfigs/Redux/actions';
import { formatDateLocale } from '../../../lib/utils.es6';

var JOURNEY_OPTIONS = ['onboarding', 'upgrade', 'claim'];
var AUTH_OPTIONS = ['none', 'bearer', 'partner_token'];

var EMPTY_FORM = {
  code: '', embed_url: '', journey_code: 'onboarding',
  auth_strategy: 'none', active: true,
  theme_primary: '', theme_secondary: '', logo_url: '',
};

class IppConfigsTab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showAddModal: false,
      showEditModal: false,
      showDeleteConfirm: false,
      selectedItem: null,
      form: Object.assign({}, EMPTY_FORM),
    };
    this.openAdd = this.openAdd.bind(this);
    this.openEdit = this.openEdit.bind(this);
    this.openDelete = this.openDelete.bind(this);
    this.handleCreate = this.handleCreate.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.setField = this.setField.bind(this);
  }

  componentWillMount() {
    this.props.dispatch(getOrgIppConfigsRequest(this.props.organizationGuid));
  }

  componentDidUpdate(prevProps) {
    var d = this.props.orgIppConfigsData;
    var p = prevProps.orgIppConfigsData;
    if (d.created && !p.created) {
      this.setState({ showAddModal: false, form: Object.assign({}, EMPTY_FORM) });
    }
    if (d.updated && !p.updated) {
      this.setState({ showEditModal: false, selectedItem: null });
    }
    if (d.deleted && !p.deleted) {
      this.setState({ showDeleteConfirm: false, selectedItem: null });
    }
  }

  openAdd() {
    this.setState({ showAddModal: true, form: Object.assign({}, EMPTY_FORM) });
  }

  openEdit(item) {
    var ippData = item.ipp_data || {};
    this.setState({
      showEditModal: true,
      selectedItem: item,
      form: {
        code: item.code || '',
        embed_url: ippData.embed_url || '',
        journey_code: ippData.journey_code || 'onboarding',
        auth_strategy: ippData.auth_strategy || 'none',
        active: item.active !== false,
        theme_primary: (ippData.theme && ippData.theme.primary) || '',
        theme_secondary: (ippData.theme && ippData.theme.secondary) || '',
        logo_url: (ippData.theme && ippData.theme.logo_url) || '',
      },
    });
  }

  openDelete(item) {
    this.setState({ showDeleteConfirm: true, selectedItem: item });
  }

  setField(name, value) {
    this.setState(function(s) {
      return { form: Object.assign({}, s.form, { [name]: value }) };
    });
  }

  buildPayload() {
    var f = this.state.form;
    return {
      organization_guid: this.props.organizationGuid,
      code: f.code,
      active: f.active,
      ipp_data: {
        embed_url: f.embed_url,
        journey_code: f.journey_code,
        auth_strategy: f.auth_strategy,
        theme: { primary: f.theme_primary, secondary: f.theme_secondary, logo_url: f.logo_url },
      },
    };
  }

  handleCreate() {
    this.props.dispatch(createOrgIppConfigRequest(this.buildPayload()));
  }

  handleUpdate() {
    var payload = Object.assign({}, this.buildPayload(), {
      guid: this.state.selectedItem.guid,
    });
    this.props.dispatch(updateOrgIppConfigRequest(payload));
  }

  handleDelete() {
    this.props.dispatch(deleteOrgIppConfigRequest({
      guid: this.state.selectedItem.guid,
      organization_guid: this.props.organizationGuid,
    }));
  }

  renderFormFields() {
    var f = this.state.form;
    var inputStyle = {
      display: 'block', width: '100%', padding: '8px',
      marginTop: 4, boxSizing: 'border-box', borderRadius: 4,
      border: '1px solid #D1D5DB', fontSize: 14,
    };
    var labelStyle = { fontWeight: 600, fontSize: 13, color: '#374151' };
    return (
      <Grid container spacing={2} style={{ marginTop: 4 }}>
        <Grid item xs={12} sm={6}>
          <label style={labelStyle}>Code *</label>
          <input style={inputStyle} value={f.code}
            onChange={function(e) { this.setField('code', e.target.value); }.bind(this)}
            placeholder="e.g. funeral_onboarding"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <label style={labelStyle}>Journey Type *</label>
          <select style={inputStyle} value={f.journey_code}
            onChange={function(e) { this.setField('journey_code', e.target.value); }.bind(this)}>
            {JOURNEY_OPTIONS.map(function(o) {
              return <option key={o} value={o}>{o}</option>;
            })}
          </select>
        </Grid>
        <Grid item xs={12}>
          <label style={labelStyle}>Embed URL *</label>
          <input style={inputStyle} value={f.embed_url}
            onChange={function(e) { this.setField('embed_url', e.target.value); }.bind(this)}
            placeholder="https://ipp.example.com/onboarding"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <label style={labelStyle}>Auth Strategy</label>
          <select style={inputStyle} value={f.auth_strategy}
            onChange={function(e) { this.setField('auth_strategy', e.target.value); }.bind(this)}>
            {AUTH_OPTIONS.map(function(o) {
              return <option key={o} value={o}>{o}</option>;
            })}
          </select>
        </Grid>
        <Grid item xs={12} sm={6}>
          <label style={labelStyle}>Primary Colour</label>
          <input style={inputStyle} value={f.theme_primary}
            onChange={function(e) { this.setField('theme_primary', e.target.value); }.bind(this)}
            placeholder="#2E7D32"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <label style={labelStyle}>Secondary Colour</label>
          <input style={inputStyle} value={f.theme_secondary}
            onChange={function(e) { this.setField('theme_secondary', e.target.value); }.bind(this)}
            placeholder="#1565C0"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <label style={labelStyle}>Logo URL</label>
          <input style={inputStyle} value={f.logo_url}
            onChange={function(e) { this.setField('logo_url', e.target.value); }.bind(this)}
            placeholder="https://cdn.example.com/logo.png"
          />
        </Grid>
        <Grid item xs={12}>
          <label style={{ fontWeight: 600, fontSize: 13, color: '#374151', cursor: 'pointer' }}>
            <input type="checkbox" checked={f.active}
              onChange={function(e) { this.setField('active', e.target.checked); }.bind(this)}
              style={{ marginRight: 8 }}
            />
            Active
          </label>
        </Grid>
      </Grid>
    );
  }

  renderCard(item) {
    var ippData = item.ipp_data || {};
    return (
      <Grid item xs={12} sm={6} md={4} key={item.guid}>
        <Box sx={{
          border: '1px solid #E5E7EB', borderRadius: 2,
          overflow: 'hidden', height: '100%',
          display: 'flex', flexDirection: 'column',
        }}>
          <Box sx={{ px: 2.5, pt: 2.5, pb: 1.5, borderBottom: '1px solid #F3F4F6',
            display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
            <Box>
              <Typography variant="subtitle2" sx={{ fontWeight: 700, fontSize: 14, color: '#111827' }}>
                {item.code}
              </Typography>
              <Typography variant="body2" sx={{ fontSize: 11, color: '#9CA3AF', mt: 0.25 }}>
                {ippData.journey_code || '—'}
              </Typography>
            </Box>
            <Chip label={item.active !== false ? 'Active' : 'Inactive'} size="small"
              sx={{ height: 20, fontSize: 11, fontWeight: 600,
                bgcolor: item.active !== false ? '#F0FDF4' : '#FEF2F2',
                color: item.active !== false ? '#15803D' : '#B91C1C',
                border: item.active !== false ? '1px solid #BBF7D0' : '1px solid #FECACA' }} />
          </Box>
          <Box sx={{ px: 2.5, py: 1.5, flex: 1 }}>
            {ippData.embed_url && (
              <Typography variant="body2" sx={{ fontSize: 12, color: '#6B7280',
                wordBreak: 'break-all', mb: 1 }}>
                {ippData.embed_url}
              </Typography>
            )}
            <Typography variant="body2" sx={{ fontSize: 11, color: '#9CA3AF' }}>
              Auth: {ippData.auth_strategy || 'none'}
            </Typography>
            <Typography variant="body2" sx={{ fontSize: 11, color: '#9CA3AF', mt: 0.5 }}>
              Created: {item.created_at ? formatDateLocale(item.created_at) : '—'}
            </Typography>
          </Box>
          <Box sx={{ px: 2.5, py: 1.5, borderTop: '1px solid #F3F4F6',
            display: 'flex', gap: 1 }}>
            <ButtonInc btnType="secondary"
              onClick={function() { this.openEdit(item); }.bind(this)}
              style={{ flex: 1, fontSize: 12 }}>
              Edit
            </ButtonInc>
            <ButtonInc btnType="secondary"
              onClick={function() { this.openDelete(item); }.bind(this)}
              style={{ flex: 1, fontSize: 12, color: '#B91C1C', borderColor: '#FECACA' }}>
              Delete
            </ButtonInc>
          </Box>
        </Box>
      </Grid>
    );
  }

  render() {
    var d = this.props.orgIppConfigsData;
    var s = this.state;
    var list = d.list || [];

    if (d.loading) {
      return <SkeletonWrapper loading={true} />;
    }

    return (
      <div>
        <Box sx={{ display: 'flex', justifyContent: 'space-between',
          alignItems: 'center', mb: 3 }}>
          <Box>
            <Typography variant="h6" sx={{ fontWeight: 700, fontSize: 16, color: '#111827' }}>
              IPP Embeddable Configs
            </Typography>
            <Typography variant="body2" sx={{ fontSize: 13, color: '#6B7280', mt: 0.25 }}>
              Configure which IPP iframe launches for each journey type.
            </Typography>
          </Box>
          <ButtonInc variant="contained" onClick={this.openAdd}>
            + Add IPP Config
          </ButtonInc>
        </Box>

        {list.length === 0 ? (
          <Box sx={{ textAlign: 'center', py: 8, color: '#9CA3AF' }}>
            <Typography variant="body1" sx={{ fontSize: 15 }}>
              No IPP configs yet.
            </Typography>
            <Typography variant="body2" sx={{ fontSize: 13, mt: 0.5 }}>
              Add one to configure a policy onboarding or claim journey.
            </Typography>
          </Box>
        ) : (
          <Grid container spacing={2}>
            {list.map(this.renderCard.bind(this))}
          </Grid>
        )}

        {/* Add modal */}
        <ModalInc modalTitle="Add IPP Config" open={s.showAddModal}
          close={function() { this.setState({ showAddModal: false }); }.bind(this)}
          fullWidth maxWidth="sm"
          modalButtons={[
            <ButtonInc key="cancel" btnType="secondary"
              onClick={function() { this.setState({ showAddModal: false }); }.bind(this)}>
              Cancel
            </ButtonInc>,
            <ButtonInc key="save" variant="contained" loading={d.creating}
              onClick={this.handleCreate}>
              Save
            </ButtonInc>,
          ]}>
          {this.renderFormFields()}
        </ModalInc>

        {/* Edit modal */}
        <ModalInc modalTitle="Edit IPP Config" open={s.showEditModal}
          close={function() { this.setState({ showEditModal: false }); }.bind(this)}
          fullWidth maxWidth="sm"
          modalButtons={[
            <ButtonInc key="cancel" btnType="secondary"
              onClick={function() { this.setState({ showEditModal: false }); }.bind(this)}>
              Cancel
            </ButtonInc>,
            <ButtonInc key="save" variant="contained" loading={d.updating}
              onClick={this.handleUpdate}>
              Save
            </ButtonInc>,
          ]}>
          {this.renderFormFields()}
        </ModalInc>

        {/* Delete confirm */}
        {s.showDeleteConfirm && (
          <AlertDialog show={s.showDeleteConfirm} title="Delete IPP Config"
            type="warning" showConfirm confirmBtnText="Delete" showCancel
            onConfirm={this.handleDelete}
            onCancel={function() {
              this.setState({ showDeleteConfirm: false, selectedItem: null });
            }.bind(this)}>
            Delete IPP config <strong>{s.selectedItem && s.selectedItem.code}</strong>? This cannot be undone.
          </AlertDialog>
        )}

        {/* Success / error alerts */}
        {d.createError && (
          <AlertDialog show={!!d.createError} title="Error" type="danger"
            showConfirm confirmBtnText="OK"
            onConfirm={function() {
              this.props.dispatch(resetCreateOrgIppConfigError());
            }.bind(this)}>
            {d.createError.message || JSON.stringify(d.createError)}
          </AlertDialog>
        )}
        {d.updateError && (
          <AlertDialog show={!!d.updateError} title="Error" type="danger"
            showConfirm confirmBtnText="OK"
            onConfirm={function() {
              this.props.dispatch(resetUpdateOrgIppConfigError());
            }.bind(this)}>
            {d.updateError.message || JSON.stringify(d.updateError)}
          </AlertDialog>
        )}
        {d.deleteError && (
          <AlertDialog show={!!d.deleteError} title="Error" type="danger"
            showConfirm confirmBtnText="OK"
            onConfirm={function() {
              this.props.dispatch(resetDeleteOrgIppConfigError());
            }.bind(this)}>
            {d.deleteError.message || JSON.stringify(d.deleteError)}
          </AlertDialog>
        )}
      </div>
    );
  }
}

export default connect(function(state) {
  return { orgIppConfigsData: state.orgIppConfigsData };
})(IppConfigsTab);
